<app-profile-header></app-profile-header>



<section class="body-section">
    <div class="container">
        <main>
            <!-- <a class="mobile-header" onclick="history.back()">
                <img src="../../../../../assets/img/login/back.svg" alt="">
              </a> -->
            <div class="col-md-12 d-flex justify-content-center mb-3 headers-headings mobile-header-div">
                <a onclick="history.back()" class="mobile-header"><i class="bx bx-chevron-left"></i> My Schedule </a>
            </div>
            <div class="row">
                <div class="col-md-4 box mb-0">
                    <div class="titles">
                        <h2 class="text-sm">Scheduled Sessions</h2>
                        <button (click)="onClickCreateSchedule()"> <i class='bx bx-plus'></i>
                            <span>Create <span>Schedule</span> </span>

                        </button>
                    </div>
                    <div class="not-found-error-ms" *ngIf="!scheduleList.length">
                        <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                            <h4>No Schedule Available!</h4>
                            <p class="text-center mt-2">There are no scheduled session for the <span
                                    *ngIf="scheduleList.length == 0">{{selectedDate | date:"dd-MM-yyyy"}} </span>
                                day.<br>
                                Please create a schedule</p>
                        </div>
                    </div>
                    <div *ngIf="scheduleList.length > 0" class="list-of-shedules">
                        <div *ngFor="let schedule of scheduleList" class="time-details">

                            <div class="media">
                                <div class="media-left">
                                    <div class="shecdul-icon">
                                        <i class='bx bx-calendar'></i>
                                    </div>
                                </div>
                                <div class="media-body">
                                    <div class="time">

                                        <!-- {{ schedule.startDate | date:'MMM d, y, h:mm:ss a' }} -->
                                        {{ schedule.startDate | date:'medium' }}
                                    </div>
                                    <div class="location">
                                        Charges Per Hour {{schedule.charges|currency:'INR'}}
                                    </div>
                                    <div class="Amenities">
                                        <span class="tx-2">Amenities: {{schedule.ament}}</span>
                                    </div>
                                    <div class="description" *ngIf="showDescription">
                                        <span class="tx-2 mb-0" *ngIf="schedule.description">
                                            Description: {{ schedule.showMore ? schedule.description : (schedule.description | slice: 0:18) }}
                                            <span *ngIf="!schedule.showMore">..</span>
                                            <a href="javascript:;" (click)="onShow(schedule)" class="show-more-btn" *ngIf="!schedule.showMore">Show More</a>
                                            <a href="javascript:;" (click)="onShow(schedule)" class="show-less-btn" *ngIf="schedule.showMore">Show Less</a>
                                        </span> 
                                    </div>
                                </div>
                                <div class="media-right">
                                    <div class="buttons-list">
                                        <button pButton (click)="onClickEdit(schedule)" class="edite-btn"
                                            label="Submit"><i class='bx bx-pencil'></i>
                                        </button>
                                        <button pButton (click)="onClickDelete(schedule)" class="delet-btn"
                                            label="Submit"><i class='bx bx-trash'></i> </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mobile-version-notes-msg" *ngIf="scheduleListArr.length > 0">

                        <div class="no-event-div" *ngIf="!scheduleList.length == 0">
                            <span> {{scheduleList.length}} Scheduled Session Available On {{selectedDate |
                                date:"dd-MM-yyyy"}}. </span>
                        </div>
                        <div class="no-event-div" *ngIf="scheduleList.length == 0">
                            <span> No Scheduled Session Available On {{startDates | date:"dd-MM-yyyy"}} </span>
                        </div>
                    </div>

                    <div class="calnder-div-mobile d-flex justify-content-center">
                        <p-button (click)="showcalender()" icon="pi pi-calendar " label="Select Schedule Date  "
                            styleClass="p-button-success"></p-button>
                    </div>
                    <div class="list-footer-div" *ngIf="scheduleListArr.length > 0">

                        <div class="no-event-div" *ngIf="!scheduleList.length == 0">
                            <span> {{scheduleList.length}} Scheduled Session Available On {{startDates |
                                date:"dd-MM-yyyy"}}. </span>
                        </div>
                        <div class="no-event-div" *ngIf="scheduleList.length == 0">
                            <span> No Scheduled Session Available On {{selectedDate | date:"dd-MM-yyyy"}} </span>
                        </div>
                        <p-paginator appendTo="body" [rows]="10" #paginator [totalRecords]="totalRecords"
                            (onPageChange)="getScheduleList($event)" [rowsPerPageOptions]=" pagination">
                        </p-paginator>
                    </div>
                </div>
                <div class="col-md-8 calender-section-div" [ngClass]="mobileCalender ? 'mobileCalender-show' : ''">
                    <div class="bottom-container matches-table  p-0">
                        <div class="box transaction-box ">

                            <div class="create-schedule" *ngIf="showCreateSchedule">
                                <!-- <div *ngIf="scheduleList.length == 0">
                                    <span> {{selectedDate | date:"dd-MM-yyyy"}} day has no scheduled events. </span>
                                </div> -->
                                <button (click)="onClickCreateSchedule()"> <i class='bx bx-plus'></i>
                                    <span>Create <span>Schedule</span></span>

                                </button>


                            </div>
                            <div class="mobile-popup-header">
                                <div class="media">
                                    <div class="media-body">
                                        <h4>Schedule Calendar</h4>
                                    </div>
                                    <div class="media-right">
                                        <button (click)="hidecalender()" class="mobile-close"> <i
                                                class='pi pi-times'></i> </button>

                                    </div>
                                </div>
                            </div>
                            <div id="calendar" class="calendar">
                                <full-calendar [options]="options"></full-calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<!-- Button trigger modal -->
<!-- Modal -->
<p-dialog [closable]="true" header="Create Schedule" [(visible)]=" showCreateScheduleForm" [modal]="true"
    [style]="{width: '500px' }" [breakpoints]="{'960px': '60vw', '768px': 'calc(100vw - 30px)'}" [baseZIndex]="10000"
    (onHide)="onCreateScheduleModalClose()" [draggable]="false" [resizable]="false" class="createShedule-popup">
    <!-- <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable"> -->
    <!-- <div class="modal-content"> -->
    <ng-template pTemplate="header" *ngIf="isAdd">
        {{header}}
    </ng-template>

    <div class="modal-body">
        <div class="schedule-forms-div ">
            <form [formGroup]="scheduleForm" *ngIf="this.scheduleForm" (ngSubmit)="onSubmit()">
                <div class="row mb-3">
                    <div class="col12">
                        <label for="exampleInputEmail1" class="form-label">Select Date :</label>
                        <p-calendar formControlName="date" yearNavigator="true" [minDate]="minDate" appendTo="body"
                            [defaultDate]="defaultDate" (onSelect)="onSelectDate($event)" yearRange="2022:2050"
                            class="p-calendar w-100" inputId="calendar" dateFormat="dd-mm-yy" [showIcon]="true"
                            [ngClass]="{ 'is-invalid': submitted && f.date.errors}" [readonlyInput]="true"></p-calendar>
                        <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                            <div *ngIf="f.date.errors.required">Please select date</div>
                        </div>
                    </div>
                    <div class="col12">
                        <div *ngIf="recurringDisabled" class="aminites available-section ">
                            <ul>
                                <li *ngFor="let recurring of recurringArray">
                                    <!-- {{recurring.status}} -->
                                    <label for="{{recurring.slug}}">

                                        <p-checkbox binary="true" formControlName="{{recurring.slug}}"
                                            inputId="{{recurring.slug}}" [value]="recurring"
                                            (onChange)="onRecurringCheckboxSelect(recurring, $event)"></p-checkbox>
                                        {{recurring.name}}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row mb-3" style="gap: 20px;">
                    <div class="col">
                        <label for="exampleInputEmail1" class="form-label">Select Time :</label>
                        <div class="time-form-field">
                            <p-calendar [timeOnly]="true" [default]="" formControlName="time" [readonlyInput]="true"
                                appendTo="body" [icon]="pi-clock" placeholder="hh:mm" [minDate]="minTime"
                                [defaultDate]="minTime" hourFormat="12"
                                [ngClass]="{ 'is-invalid': submitted && f.time.errors}" [showIcon]="false"
                                class="w-100"> </p-calendar><i class="pi pi-clock ico-div"></i>
                        </div>

                        <div *ngIf="submitted && f.time.errors" class="invalid-feedback">
                            <div *ngIf="f.time.errors.required">Please select time</div>
                        </div>
                    </div>
                    <div class="col">
                        <label for="exampleInputEmail1" class="form-label">Charges Per Hour :</label>
                        <p-inputNumber formControlName="charges" placeholder="Enter Charges Per Hour"
                            [ngClass]="{ 'is-invalid': submitted && f.charges.errors}"></p-inputNumber>
                        <div *ngIf="submitted && f.charges.errors" class="invalid-feedback">
                            <div *ngIf="f.charges.errors.required">Please enter charges</div>
                            <div *ngIf="!f.charges.errors.required && f.charges.errors">Minimum 100 Rupees</div>

                        </div>
                    </div>
                </div>
                <div class="row mb-3 state-row">
                    <!-- <div class="col">
                        <label for="exampleInputEmail1" class="form-label">Select Country :</label>
                        <p-dropdown inputId="country" [options]="countryList" formControlName="country" [filter]="true"
                            (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name"
                            [ngClass]="{ 'is-invalid': submitted && f.country.errors }"></p-dropdown>
                        <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                            <div *ngIf="f.country.errors.required">Please select country</div>
                        </div>
                    </div> -->
                    <div class="col-6 state-div">
                        <label for="exampleInputEmail1" class="form-label">Select State :</label>
                        <p-dropdown inputId="state" [options]="stateList" formControlName="state" [filter]="true"
                            (onChange)="getCities('true', $event)" placeholder="Select State" optionLabel="name"
                            appendTo="body"
                            [ngClass]="{ 'is-invalid': submitted && (f.state.invalid && (f.state.dirty || f.state.touched))}"></p-dropdown>
                        <div *ngIf="((submitted && f.state.errors) || (f.state.errors && (f.state.dirty || f.state.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.state.errors.required">Please Select State
                            </div>
                        </div>
                    </div>
                    <div class="col-6 city-div">
                        <label for="exampleInputEmail1" class="form-label">Select City :</label>
                        <p-dropdown inputId="city" [options]="cityList" formControlName="city" [filter]="true"
                            appendTo="body" placeholder="Select City" optionLabel="name"
                            (onChange)="onCitySelect($event)"
                            [ngClass]="{ 'is-invalid': submitted && (f.city.invalid && (f.city.dirty || f.city.touched))}"></p-dropdown>
                        <div *ngIf="((submitted && f.city.errors) || (f.city.errors && (f.city.dirty || f.city.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.city.errors.required">Please Select City
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">

                    <div class="col venue-div">
                        <label for="exampleInputEmail1" class="form-label">Venue :</label>
                        <input type="text" class="form-control" formControlName="venue" pInputText
                            placeholder="Enter Venue" aria-label="Last name"
                            [ngClass]="{ 'is-invalid': submitted && f.venue.errors }">
                        <div *ngIf="submitted && f.venue.errors" class="invalid-feedback">
                            <div *ngIf="f.venue.errors.required">Please enter venue</div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label for="exampleInputEmail1" class="form-label">Select Amenities :</label>
                        <ul class="Amenities-list-select">
                            <li *ngFor="let amenities of amenitiesArray">
                                <div (click)="onClickAmenities(amenities)" class="aminites">
                                    <div class="icon-div">
                                        <div class="icon">
                                            <img src="{{amenities.img}}" alt="">
                                        </div>
                                        <div *ngIf="amenities.selected" class=" d-block selected-icon">
                                            <i class="bx bxs-check-circle"></i>
                                        </div>
                                    </div>
                                    <div class="name">
                                        <h4>{{amenities.name}}</h4>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row mb-3" *ngIf="showDescription">
                    <div class="col venue-div">
                        <label for="exampleInputEmail1" class="form-label">Description :</label>
                        <textarea type="text" class="form-control" formControlName="description" pInputText
                            placeholder="" aria-label="" rows="4" cols="50"
                            [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>

                    </div>
                </div>
                <!-- <div class="modal-footer text-center justify-content-center ">
                    <button type="submit" class="btn btn-primary p-0">
                        <span *ngIf="isAdd">Create Schedule</span>
                        <span *ngIf="!isAdd">Update Schedule</span>
                    </button>
                </div> -->
            </form>
        </div>
    </div>

    <!-- </div> -->
    <!-- </div> -->
    <ng-template pTemplate="footer">
        <div class="modal-footer text-center justify-content-center ">
            <form [formGroup]="scheduleForm" *ngIf="this.scheduleForm" (ngSubmit)="onSubmit()">
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAdd">Create Schedule</span>
                    <span *ngIf="!isAdd">Update Schedule</span>
                </button>
            </form>
        </div>
    </ng-template>
</p-dialog>
<!-- <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog> -->
<!-- <p-confirmDialog #cd [style]="{ width: '450px' }"  id="confirmation_box">
    <ng-template pTemplate="header">
        <h3>{{messageConfirmation}} </h3>
    </ng-template>
{{messageConfirmation}}
    <ng-template pTemplate="footer">
        <p>Message Template</p>

        <div class="delet-all">
            <p-multiSelect [options]="deleteItems" [showToggleAll]="false" [(ngModel)]="selectedCities" (ngModelChange)="onSelectionChange()" [filter]="true" optionLabel="name" placeholder="Delete All Sessions?"></p-multiSelect>
        </div>

       <div class="footer-btn">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()" class="cancel-btn"></button>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"></button>    
       </div>
    </ng-template>
</p-confirmDialog> -->
<p-dialog header="Delete Schedule" [(visible)]="deleteSheduleModal" [modal]="true"
    [style]="{ width: '500px',height: 'auto' }" [draggable]="false" [resizable]="false" id="delete-popup"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" (onHide)="onCloseClick()">
    <ng-template pTemplate="body" class="modal-body">
        <div class="content-msg d-flex">
            <div class="icon">
                <div class="icons-div">
                    <i class="pi pi-exclamation-triangle"></i>
                </div>
                <div class="icons-body">

                    {{this.messageConfirmation}}
                </div>
            </div>
        </div>
        <div class="delet-all">
            <p>If You Want To Delete All Sessions?</p>
            <p-multiSelect appendTo="body" [options]="deleteItems" [showToggleAll]="false" [(ngModel)]="selectedCities"
                (ngModelChange)="onSelectionChange()" [filter]="false" optionLabel="name" [showClear]="true"
                placeholder="Select Option"></p-multiSelect>
        </div>
    </ng-template>
    <ng-template pTemplate="footer" class="modal-footer">

        <div class="footer-btn">
            <button type="button" class="cancel-btn" pButton label="Cancel"
                (click)="deleteSheduleModal = false"></button>

            <button type="button" class="delete-btn" pButton icon="pi pi-trash" label="Delete"
                (click)="onClickConfirmDelete()"></button>
        </div>

    </ng-template>
</p-dialog>
<p-toast key="toastmsg" position="top-right"></p-toast>